/**
 * E8. Пирамида: «знакомый» предлагает вложение под 40 % в год. Сумма
 * ползунком до всех сбережений, «Вложить» или «Отказаться». Что будет
 * дальше, написано в строке ожидания каркаса (крах на третий год с p 85 %).
 * «Спросить N» (когорта) — план 4.
 */
import { t } from '@life/i18n';
import type { PyramidInput, PyramidState } from '@life/minigames';
import { money } from '../lib/format';
import type { MinigameScreenProps } from './types';
import { Bet, betCap, useBet } from './ui/Bet';

export function Pyramid({ state, life, onInput }: MinigameScreenProps<PyramidInput, PyramidState>) {
  const cap = betCap(state.maxInvest, life.money);
  const [sum, setSum] = useBet(cap);
  return (
    <>
      <p>{t('ui.minigame.pyramid.offer', { yield: Math.round(state.promisedYield * 100) })}</p>
      <Bet cap={cap} value={sum} onChange={setSum} label={t('ui.minigame.pyramid.sum')} />
      <div class="picks">
        <button type="button" class="btn accent" disabled={sum <= 0} onClick={() => onInput({ invest: sum })}>
          {t('ui.minigame.pyramid.invest', { sum: money(sum) })}
        </button>
        <button type="button" class="btn" onClick={() => onInput({ decline: true })}>
          {t('ui.minigame.pyramid.decline')}
        </button>
      </div>
    </>
  );
}
